import React from "react";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { AllLedgersListType } from "../../../../redux/clientSettings/clientSettingTypes";
import { TableLoader, TableHeader } from "../../../commons";
import InfiniteLoader from "../../../commons/InfiniteLoader/InfiniteLoader";
import ScrollToTop from "../../../commons/ScrollToTop";
import AccountsManagerTableData from "./AccountsManagerTableData";

type AppProps = {
  data: [] | AllLedgersListType[];
  headers: TableHeadersType[];
  fetching: boolean;
  handleEditAccountDetails: (data: AllLedgersListType) => void;
  isEditAccountPresent: boolean;
  offset: number;
  handleEnableDisableStatus:(data:any)=>void;
  isChangeStatusCustomerSupplierPresent:boolean;
};

const AcccountsManagerTable = ({
  fetching,
  headers,
  data,
  offset,
  handleEditAccountDetails,
  isEditAccountPresent,
  handleEnableDisableStatus,
  isChangeStatusCustomerSupplierPresent
}: AppProps) => {
  return (
    <>
      {fetching && offset === 0 ? (
        <TableLoader Rows={10} ColumnPerRow={3} />
      ) : (
        <div className="jobsType">
          <table className="table table-bordered thead-light">
            <thead className="sticky-table-header">
              <TableHeader tableHeader={headers} extraHeader />
            </thead>
            <tbody>
              <AccountsManagerTableData
                data={data?.filter(
                  (el: any) => el?.ledger_number !== "10000009"
                )}
                tableHeader={headers}
                handleEditAccountDetails={handleEditAccountDetails}
                isEditAccountPresent={isEditAccountPresent}
                handleEnableDisableStatus={handleEnableDisableStatus}
                isChangeStatusCustomerSupplierPresent={isChangeStatusCustomerSupplierPresent}
              />
              <div style={{ display: fetching ? "none" : "inline" }}>
                <ScrollToTop />
              </div>
              {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default AcccountsManagerTable;
